import { SvgIcon } from '@mui/material';

const PreparedIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
      >
        <path
          d="M6.334 1v2m2-2v2m2-2v2m-7 2h10a.5.5 0 0 1 .5.5v6a1.494 1.494 0 0 1-1.5 1.5h-8a1.494 1.494 0 0 1-1.5-1.5v-6a.5.5 0 0 1 .5-.5m12.5 1-2 1.5M.834 6l2 1.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default PreparedIcon;
